const module = { name: 'global/consts', exports: {} }; const exports = module.exports;



const CookieNames = Object.freeze({
    AGE_VERIFICATION: 'ageverification',
    AKAMAI_LOCATION: 'akamai_generated_location',
    CHAIN_CODE: 'ChainCode',
    COVID_ANNOUNCEMENT_MODAL: 'covid-modal-v',
    EXPANDED_SEARCH: 'expandedSearch',
    FREEWHEEL_USER_ID: 'fw_uid',
    HUB: 'hub',
    PARTNER_CAMP: 'partner-camp',
    USER_COUNTRY: 'userCountry',
    USER_LOCATION: 'userlocation',
    CCPA_OPT_OUT_STATUS: 'usprivacy',
    ONETRUST_GPP_CONSENT: 'OTGPPConsent',
    FBC: '_fbc',
    FBP: '_fbp',
    KD_CLID: 'kdClid',
    LOGGED_IN_ACCESS_TOKEN: 'access-token',
    LOGGED_IN_ID_TOKEN: 'id-token',
    SNAPCHAT_ID: '_scid',
    SNAPCHAT_CLICK_ID: 'ScCid',
    TIK_TOK: 'ttclid',
    FOGLIA_CART_ID: 'foglia-cart-id',
    RISK_METRICS_REFERENCE_ID: 'RiskMetricsReferenceId',
    SEAT_SELECTION_COMPLETED: 'seat-selection-completed',
})


const FanClubPlanTerms = Object.freeze({
    ANNUAL: 'annual',
    MONTHLY: 'monthly',
})


const MOPViewTypes = Object.freeze({
    IN_THEATERS: 'buytickets',
    ON_DEMAND: 'athome',
})


const QueryParams = Object.freeze({
    AFFILIATE_ID: 'a',
    BUY_TICKETS_BTN: 'buyticketsbutton',
    CAMPAIGN: 'cmp',
    CHAIN_ID: 'chainID',
    DATE: 'date',
    FAN_CLUB_ACTION: 'action',
    FAN_CLUB_PLAN_ID: 'planId',
    FILTER: 'filter',
    FORMAT: 'format',
    MOVE_TO: 'move-to',
    MPX_ID: 'mpxId',
    NO_THEATER_URL: 'notheaterurl',
    PAGE: 'pn',
    SNAPCHAT_CLICK_ID: 'ScCid',
    START_DATE: 'startdate',
    THEATER: 'theater',
    VIEWING: 'viewing',
})
function extendLegacy(publicInterface, sectionName) {
    window.Fandango = window.Fandango || {};
    const { Fandango } = window;
    if (!Fandango[sectionName]) {
        Fandango[sectionName] = publicInterface;
    }
}
module.exports = {
    CookieNames,
    FanClubPlanTerms,
    MOPViewTypes,
    QueryParams,
};
extendLegacy(module.exports, 'consts');
export default module.exports;